import Vue from "vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";

require("./bootstrap");
window.Vue = require("vue");

Vue.config.productionTip = false;

Vue.use(Vuetify);
Date.prototype.isWithinWeek = function(txtDate) {
    var today = new Date(),
        nextWeek = Date.parse(
            new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7)
        );

    if (Date.parse(this) >= Date.parse(today) && Date.parse(this) <= nextWeek) {
        return true;
    } else {
        return false;
    }
};

Date.prototype.addDays = function(days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

Date.prototype.yyyymmdd = function() {
    var mm = this.getMonth() + 1, // getMonth() is zero-based
        dd = this.getDate();

    return [
        this.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd
    ].join("-");
};

Date.prototype.isToday = function() {
    const today = new Date();

    return (
        this.getDate() === today.getDate() &&
        this.getMonth() === today.getMonth() &&
        this.getFullYear() === today.getFullYear()
    );
};

Date.prototype.isPast = function() {
    const today = new Date();
    return this.getTime() < today.getTime();
};

Vue.mixin({
    methods: {
        getUserSwitchLabel(val) {
            return val ? "Active" : "Inactive";
        },

        getHeaders(items) {
            let s = new Set();
            var f;

            items.forEach(item => {
                for (f in item) {
                    s.add(f);
                }
            });

            return Array.from(s).map(a => {
                return {
                    text: a.toUpperCase(),
                    value: a
                };
            });
        },

        getDefaultWeek() {
            var now = new Date();

            var daysAfterLastThursday = -7 + 4 - now.getDay(), // 7 = number of days in week, 4 = the thursdayIndex (0= sunday)
                currentMs = now.getTime(),
                lastThursday = new Date(
                    currentMs + daysAfterLastThursday * 24 * 60 * 60 * 1000
                ),
                endRange = new Date(
                    lastThursday.getFullYear(),
                    lastThursday.getMonth(),
                    lastThursday.getDate()
                );

            return [lastThursday.yyyymmdd(), endRange.addDays(6).yyyymmdd()];
        },

        getCurrentMonth() {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            return [firstDay.yyyymmdd(), lastDay.yyyymmdd()];
        },

        sum(items, prop) {
            let amount = items.reduce(function(a, b) {
                return a + (parseFloat(b[prop]) || 0);
            }, 0);

            return amount % 1 === 0 ? amount : amount.toFixed(2);
        },


        avg(items, prop) {
            var total = items.reduce(function(a, b) {
                return a + (parseFloat(b[prop]) || 0);
            }, 0);

            var avg = total / items.length;

            return avg.toFixed(2) || 0;
        },

        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },

        getInitials(name) {
            let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");

            let initials = [...name.matchAll(rgx)] || [];

            initials = (
                (initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")
            ).toUpperCase();

            return initials;
        },

        checkGate(gate) {
            return this.$store.getters.ability.includes(gate);
        }
    }
});

import App from "./components/App";

const app = new Vue({
    el: "#app",
    vuetify: new Vuetify({
        //theme: {dark : true }
    }),
    components: {
        App
    },
    router,
    store,
    methods: {}
});
